<div class="row">
    <div class="col-lg-12">
        <div class="row action-toolbar">
            <div class="col-12">
                <form class="form-inline">
                    <action-toolbar-count [grid]="grid"></action-toolbar-count>
                    <action-toolbar-buttons
                        [grid]="grid"
                        [canEdit]="canEdit"
                        [showAdd]="true"
                        [showEdit]="true"
                        [showDelete]="true"
                    ></action-toolbar-buttons>
                    <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <wj-flex-grid
                    #mainGrid
                    appAutoSize
                    [minHeight]="200"
                    (initialized)="grid.initialize(mainGrid); onGridInitialized()"
                    (destroy)="grid.destroy()"
                    [itemsSource]="grid.view"
                >
                    <wj-flex-grid-filter></wj-flex-grid-filter>
                    <wj-flex-grid-column
                        [header]="'Description of Work'"
                        [binding]="'descriptionOfWork'"
                        [width]="180"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Material Type'" [binding]="'materialType'" [width]="130"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Vendor'" [binding]="'vendor'" [dataMap]="vendorMap" [width]="150"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Product'" [binding]="'product'" [width]="130"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Minimum Lift'" [binding]="'minimumLift'" [width]="110"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Required Depth'" [binding]="'requiredDepth'" [width]="120"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Min. Test Frequency'" [binding]="'minimumTest'" [width]="150"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Required Compaction'"
                        [binding]="'requiredCompaction'"
                        [width]="150"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Max Density and Optimum Moisture'"
                        [binding]="'optimumMoisture'"
                        [width]="200"
                    ></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Pit Location'" [binding]="'pitLocation'" [width]="140"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Proctor Date'" [binding]="'proctorDate'" [width]="120"></wj-flex-grid-column>
                    <wj-flex-grid-column [header]="'Dispatch Contact'" [binding]="'dispatchContact'" [width]="150"></wj-flex-grid-column>
                    <wj-flex-grid-column
                        [header]="'Testing Company'"
                        [binding]="'testingCompanyVendorId'"
                        [dataMap]="testingCompanyMap"
                        [width]="150"
                    ></wj-flex-grid-column>
                </wj-flex-grid>
            </div>
        </div>
    </div>
</div>
